import { Sparkles } from 'lucide-react';

interface FilmplyBadgeProps {
  text?: string;
  className?: string;
  thinking?: boolean;
}

/**
 * Filmply branding component - consistent AI persona styling
 *
 * Usage:
 * - <FilmplyBadge /> → "✨ Filmply"
 * - <FilmplyBadge text="thinks you'd like:" /> → "✨ Filmply thinks you'd like:"
 * - <FilmplyBadge thinking /> → "✨ Filmply is thinking..." (with animation)
 */
export function FilmplyBadge({ text, className = '', thinking = false }: FilmplyBadgeProps) {
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`}>
      <Sparkles
        className={`w-4 h-4 text-teal-400 ${thinking ? 'animate-pulse' : ''}`}
      />
      <span className="text-teal-400 font-medium">Filmply</span>
      {thinking ? (
        <span className="text-slate-400">
          is thinking
          <span className="inline-flex w-6">
            <span className="animate-bounce" style={{ animationDelay: '0ms' }}>.</span>
            <span className="animate-bounce" style={{ animationDelay: '150ms' }}>.</span>
            <span className="animate-bounce" style={{ animationDelay: '300ms' }}>.</span>
          </span>
        </span>
      ) : (
        text && <span className="text-slate-300">{text}</span>
      )}
    </span>
  );
}
